import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupFixedAsset } from "../../../Shared/NewForms/NFLookupFixedAsset";

export const FixedAssetsMovingsDetailAssets = () => {
    const { t } = useTranslation();

    useEffect(() => {}, []);

    return (
        <>
            <NFormTable fieldArray={"fixedAssets"}>
                <NFTextInput fieldName="lineNo" title={t("lineNo")} />
                <NFLookupFixedAsset
                    fieldName="fixedAssetsMovingId"
                    title={t("Fixed Assets Moving Id")}
                />
                <NFLookupFixedAsset
                    fieldName="fixedAssetId"
                    title={t("Fixed Asset Id")}
                />
            </NFormTable>
        </>
    );
};
